import { get } from '@/base/http-base.js'

/**
 * 查询实例券类型
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getInstanceType(params) {
  return get('/localAPI/instanceType', params, {
    isLoading: false
  })
}

/**
 * 查询使用明细列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getResourceUseList(params) {
  return get('/localAPI/useList', params, {
    target: '.loading-table',
    isRemoveField: true
  })
}

/**
 * 查询实例券列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getResourceList(params) {
  return get('/localAPI/list', params, {
    target: '.loading-table',
    isRemoveField: true
  })
}

/**
 * 导出实例券列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function exportList(params) {
  return get('/localAPI/exportList', params, {
    isRemoveField: true
  })
}

/**
 * 导出实例券使用明细
 *
 * @export
 * @param {*} params
 * @returns
 */
export function exportUseList(params) {
  return get('/localAPI/exportUseList', params, {
    isRemoveField: true
  })
}
